import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import Colors from '../../utils/color';
import IntentsSectionGrouped from './IntentsSectionGrouped';
import { OmniBarCompact } from './OmniBarCompact';

const useStyles = makeStyles<Theme>(({ spacing }) => ({
  bar: {
    display: 'flex',
    alignItems: 'stretch',
    gap: spacing(1),
    padding: spacing(1),
    backgroundColor: Colors.porcelain,
  },
  quickResponse: {
    // Grows to fill the leftover width between the Conversation and Order Flow
    // groups — the agent's primary input stays large without stretching the
    // intent buttons.
    flex: '1 1 0',
    minWidth: 280,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: Colors.white,
    border: `${spacing(0.125)} solid ${Colors.alto}`,
    borderRadius: spacing(1),
    padding: spacing(1),
  },
  inputWrap: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
  },
}));

/**
 * Full-width bottom action bar.
 *
 * IntentsSectionGrouped lays out the bar left→right: Escalation (Request Staff),
 * Conversation, then the QUICK RESPONSE OmniBar, then Order Flow (Continue /
 * Confirm / Read Back / Complete) and any trailing "More" group. The OmniBar is
 * passed in as a slot so it sits between the Conversation and Order Flow groups
 * (all share IntentsSectionGrouped's flex row) while its input styling stays here.
 */
const BottomActionBar = () => {
  const classes = useStyles();

  return (
    <div className={classes.bar}>
      <IntentsSectionGrouped
        omniBar={
          <div className={classes.quickResponse}>
            <div className={classes.inputWrap}>
              <OmniBarCompact />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default BottomActionBar;
